module.exports = __webpack_public_path__ + "img/confetti.c6499308.svg";